import { Button } from '@nespresso-design-system/components';
import useTranslations from '@/widgets/hooks/useTranslations';
import type { Translations } from '@/widgets/ProductList/config';
import { trackFiltersRemoval } from '../../../Tracking.ts';
import type { FiltersAndSort } from '@/widgets/services/FilteringAndSortingService.ts';

type ClearButtonProps = {
  filtersAndSort: FiltersAndSort;
};

function ClearButton({ filtersAndSort }: ClearButtonProps) {
  const { t } = useTranslations<Translations>();
  const cleanAllLabel = t('productList.filters.cleanFilters');
  const { filtering, sorting } = filtersAndSort;

  return (
    <Button
      label={cleanAllLabel}
      variant="outline"
      disabled={!filtering.isFiltered.value}
      onClick={() => {
        trackFiltersRemoval(filtering.currentFilters.value, 'clear all');
        filtering.clearAllFilters();
        sorting.clearSort();
      }}
      aria-label={cleanAllLabel}
    >
      {cleanAllLabel}
    </Button>
  );
}

export default ClearButton;
